import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Ladda from 'ladda';
import MainBaseView from 'views/MainBaseView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import BootstrapData from 'models/BootstrapData';
import partnerBoxMobileTemplate from 'hbars!templates/partnerBoxMobile';
import pollsMobileStyleTemplate from 'hbars!templates/pollsMobileStyle';
import pollsEmptyStateTemplate from 'hbars!templates/pollsEmptyState';
import Handlebars from 'handlebars';
import { instanaTrackPage } from '@bizzabo/instana-api';
import serviceConfig from 'config';
import { sendAnalytics } from 'client/scripts/utils/analyticsUtils';
import { initializeSnowplowTrackerIfEnabled } from '../utils/SnowplowUtils';
import { renderVirtualVenueBanner } from '../views/reactViews/VirtualVenueBanner';
import { renderAttendeeLogin } from '../views/reactViews/AttendeeLogin';
import { renderSsoEmailErrorModal } from '../views/reactViews/SsoEmailErrorModal';
import { saveUrlParamsToSessionStorage } from '../utils/saveUrlParamsToSessionStorage';

Handlebars.registerPartial('partnerBoxMobile', partnerBoxMobileTemplate);
Handlebars.registerPartial('pollsMobileStyle', pollsMobileStyleTemplate);
Handlebars.registerPartial('pollsEmptyState', pollsEmptyStateTemplate);

var MainPollListView = MainBaseView.extend({
    events: {
        'click a .mobile-polls-list-button': 'animateOpacity',
        'click .polls-list-item [data-id="open-poll-button"]': 'sendOpenPollAnalytics',
        'click .polls-list-item [data-id="view-results-button"]': 'sendViewPollResultsAnalytics',
    },

    initialize: function(options) {
        options = options || {};
        const { event, inApp } = options.bootstrapData || {};
        this.inApp = inApp;
        const accountId = event?.['account-id'];
        const eventId = event?.id;

        saveUrlParamsToSessionStorage({
            windowLocationSearch: window?.location?.search,
            eventId,
        });

        instanaTrackPage('Polls List');
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        MainBaseView.prototype.initialize.apply(this, arguments);
        Global.set('page', 'polls');
        initializeSnowplowTrackerIfEnabled();
        renderVirtualVenueBanner();
        renderAttendeeLogin();
        renderSsoEmailErrorModal();
    },

    animateOpacity: function(e) {
        $(e.currentTarget).css('opacity', 0.2);
    },

    getPollName: function(target) {
        const pollItemElem = $(target).parents('.poll-list-item-content');
        const pollTitleElem = pollItemElem.find('.poll-title-text-box-wrapper');
        const pollName = pollTitleElem.text().trim();

        return pollName;
    },

    sendOpenPollAnalytics: function(e) {
        const currentTarget = e.currentTarget;
        this.sendAnalytics('openPoll', currentTarget);
    },

    sendViewPollResultsAnalytics: function(e) {
        const currentTarget = e.currentTarget;
        this.sendAnalytics('viewPollResults', currentTarget);
    },

    sendAnalytics: function(eventName, target) {
        const pollName = this.getPollName(target);

        sendAnalytics(eventName, {
            pollName,
        });
    }
});

const event = BootstrapData('bootstrap-data-event');
const me = BootstrapData('bootstrap-data-me');
const config = BootstrapData('bootstrap-data-config');
const isJoinedObject = BootstrapData('bootstrap-data-isJoinedObject');
const siteConf = BootstrapData('bootstrap-data-siteConf');
const polls = BootstrapData('bootstrap-data-polls');
const partners = BootstrapData('bootstrap-data-partners');
const sessions = BootstrapData('bootstrap-data-sessions');
const isCookieConsentEnabled = BootstrapData('bootstrap-data-isCookieConsentEnabled');

export default new MainPollListView({
    el: $(document.body),
    bootstrapData: {
        event: event,
        eventID: event.id,
        me: me,
        config: config,
        siteConf: siteConf,
        polls: polls,
        isJoined: isJoinedObject.isJoined,
        sessions: sessions,
        partners: partners,
        isCookieConsentEnabled
    }
});



